<template>
  <div :class="['fixed-footer', { 'fixed-footer--noprint': !canPrintCerfa }]">
    <template v-if="canPrintCerfa">
      <BasicButton
        label="Générer le CERFA"
        size="small"
        @click="$emit('print')"
        icon-name="print"
        iconRight
        class="fixed-footer__imprimer fixed-footer__imprimer--desktop"
      />
      <BasicButton
        size="small"
        @click="$emit('print')"
        icon-name="print"
        class="fixed-footer__imprimer fixed-footer__imprimer--mobile"
      />
    </template>
    <div class="fixed-footer--right">
      <template v-if="mustConfirm">
        <BasicButton
          label="Reprendre la saisie de la demande"
          size="small"
          @click="$emit('accept')"
        />
        <BasicButton
          label="Refuser la demande"
          type="danger"
          variant="outlined"
          size="small"
          @click="$emit('refuse')"
        />
      </template>
      <template v-else>
        <BasicButton
          label="Enregistrer"
          size="small"
          @click="$emit('save')"
        />
        <BasicButton
          label="Transmettre"
          type="reverse"
          variant="outlined"
          size="small"
          @click="$emit('transmit')"
        />
        <BasicButton
          v-if="canRefuse"
          label="Refuser"
          type="danger"
          variant="outlined"
          size="small"
          @click="$emit('refuse')"
        />
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
  defineProps<{ canPrintCerfa: boolean; mustConfirm: boolean; canRefuse: boolean }>()
  defineEmits(['save', 'transmit', 'print', 'accept', 'refuse'])
</script>

<style scoped lang="less">
  @import './DemandeFooter.less';
</style>
